import * as d3 from 'd3'
export default {

  methods: {

    draw_Header() {

      let head = this.header
      let headCanvas = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.header.y})`)


      // Horizontal LINE
      this.gmx_Line(headCanvas, 0, this.table.width, 0, 0, '#757575', 1, 1)
      this.gmx_Line(headCanvas, 0, this.table.width, head.height, head.height, '#757575', .5, 1)

      // Vertical LINE
      // this.gmx_Line(headCanvas, this.columns[1].ex, this.columns[1].ex, 0, this.table.height, '#bcbcbc', .5, 1)
      // this.gmx_Line(headCanvas, this.columns[5].ex, this.columns[5].ex, 0, this.table.height, '#bcbcbc', .5, 1)


      this.gmx_Text(headCanvas, '', this.columns[0].mx, head.height/2+4, 11, '#000', 'middle', '', this.columns[0].name)

      if(this.columns[1].name == 'RT Extend') {
      this.gmx_Text(headCanvas, '', this.columns[1].mx, head.height/2+4, 11, '#000', 'middle', '', '')
      } else {
      this.gmx_Text(headCanvas, '', this.columns[1].mx, head.height/2+4, 11, '#000', 'middle', '', this.columns[1].name)  
      }

      this.gmx_Text(headCanvas, '', this.columns[2].mx, head.height/2 - 2, 11, '#000', 'middle', '', 'Welding')
      this.gmx_Text(headCanvas, '', this.columns[2].mx, head.height/2 + 12, 11, '#000', 'middle', '', 'Process')

      this.gmx_Text(headCanvas, '', this.columns[4].ex, head.textY[0], 11, '#000', 'middle', '', 'Weekly Performance')
      this.gmx_Text(headCanvas, '', this.columns[8].ex, head.textY[0], 11, '#000', 'middle', '', 'Cumulated Performance')


      this.columns.filter(f=> f.sub).forEach(col => {

          // this.gmx_Line(head, d.sx, d.sx, 5, tbl.headHeight-5, '#E0E0DF', .5, .9)
      if(col.name == 'RT Extend') {
        this.gmx_Text(headCanvas, '', col.mx,  head.height/2-2, col.tSize+1, '#000', 'middle', '', col.name)
        this.gmx_Text(headCanvas, '', col.mx,  head.height/2+12, 9,  '#777', 'middle', '', col.sub)
      } else {
        this.gmx_Text(headCanvas, '', col.mx,  head.textY[1], 9.5, '#333', 'middle', '', col.name)
        this.gmx_Text(headCanvas, '', col.mx,  head.textY[2], 9,  '#777', 'middle', '', col.sub)
      }

      })
    
    },


  }
}